export const VerifiedIndividualExcelHeaders = [
  { label: 'Id.', key: 'id' },
    { label: 'District', key: 'indivisual.ref_district.name' },
  { label: 'ATOM ID', key: 'atom_id' },
  { label: 'First Name', key: 'first_name' },
  { label: 'Last Name', key: 'last_name' },
    { label: 'User Type', key: 'user_category_sub_type.sub_category_name' },
  { label: 'Date Of Birth', key: 'indivisual.dob' },
  { label: 'Gender', key: 'indivisual.gender' },
  { label: 'Email', key: 'email' },
  { label: 'Mobile', key: 'indivisual.mobile' },
  { label: 'Address', key: 'indivisual.address' },
    { label: 'Identity Type', key: 'indivisual.identity_type' },
  { label: 'Identity Card', key: 'indivisual.identity_card' },
  { label: 'Kit Size', key: 'indivisual.kit_size' },
  { label: 'Shoe Size', key: 'indivisual.shoe_size' },
  { label: 'Level of Achievement', key: 'indivisual.level_of_achievement' },
  { label: 'Father Name', key: 'indivisual.father_name' },
   { label: 'Mother Name', key: 'indivisual.mother_name' },
  { label: 'Date Of Joining', key: 'indivisual.date_of_joining_training_centre' },
   { label: 'Organization Type', key: 'orgnization_type' },
  { label: 'Organization Name', key: 'orgnization_name' },
];